import {
  CasinoGame,
  WheelOfFortuneConfig,
  WheelOfFortuneRoom,
} from "@/services/types"
import { Module } from "vuex"
import {
  AsyncState,
  RootState,
  WheelOfFortuneRoomsAsMap,
  WheelOfFortuneState,
} from "@/store/types"
import { createAsyncAction } from "../utils/createAsyncAction"
import {
  getRooms,
  getRoom,
  leaveRoom,
  joinRoom,
  updateRoom,
} from "../api/wheelOfFortune/rooms"
import { getCasinoGame } from "../api/wheelOfFortune/casinoGame"
import { inviteBot } from "../api/wheelOfFortune/rooms"

const wheelOfFortuneStore: Module<WheelOfFortuneState, RootState> = {
  namespaced: true,
  state: () => ({
    rooms: {
      data: new Map(),
      loading: true,
    } as AsyncState<WheelOfFortuneRoomsAsMap>,
    roomToJoin: null as WheelOfFortuneRoom | null,
    roomToView: null as WheelOfFortuneRoom | null,
    room: {
      loading: false,
    } as AsyncState<WheelOfFortuneRoom>,
    casinoGame: {
      data: {},
      loading: true,
    } as AsyncState<CasinoGame<WheelOfFortuneConfig>>,
    inviteBot: {
      data: {},
      loading: false,
    } as AsyncState<any>,
  }),
  getters: {
    rooms: (state) => state.rooms,
    roomToJoin: (state) => state.roomToJoin,
    roomToView: (state) => state.roomToView,
    room: (state) => state.room,
    casinoGame: (state) => state.casinoGame.data,
    inviteBot: (state) => state.inviteBot,
  },
  mutations: {
    SET_ASYNC_STATE<K extends keyof WheelOfFortuneState>(
      state: WheelOfFortuneState,
      {
        key,
        patch,
      }: {
        key: K
        patch: Partial<WheelOfFortuneState[K]>
      }
    ) {
      state[key] = {
        ...state[key],
        ...patch,
      }
    },
    CLEAR_ROOMS(state) {
      state.rooms.data = new Map()
    },
    ADD_ROOM(state, room: WheelOfFortuneRoom) {
      state.rooms.data.set(room.id, room)
    },
    UPDATE_ROOM(state, updatedRoom: WheelOfFortuneRoom) {
      if (!state.rooms.data.has(updatedRoom.id)) {
        state.rooms.data.set(updatedRoom.id, updatedRoom)
      } else {
        state.rooms.data?.set(updatedRoom.id, updatedRoom)
      }

      if (state.room?.data && state.room.data.id === updatedRoom.id) {
        state.room.data = updatedRoom
      }
    },
    DELETE_ROOM(state, room: WheelOfFortuneRoom) {
      state.rooms.data.delete(room.id)
    },
    SET_ROOM_TO_JOIN(state, room: WheelOfFortuneRoom | null) {
      state.roomToJoin = room
    },
    SET_ROOM_TO_VIEW(state, room: WheelOfFortuneRoom | null) {
      state.roomToView = room
    },
    SET_ROOM(state, room: WheelOfFortuneRoom | null) {
      if (state.room) {
        state.room.data = room
      }
    },
    CLEAR_INVITE_BOT(state) {
      state.inviteBot = {
        data: {},
        loading: false,
      }
    },
  },
  actions: {
    getRooms: createAsyncAction(getRooms, "rooms"),
    getRoom: createAsyncAction(getRoom, "room"),
    getCasinoGame: createAsyncAction(getCasinoGame, "casinoGame"),
    leaveRoom: createAsyncAction(leaveRoom, "room"),
    joinRoom: createAsyncAction(joinRoom, "room"),
    updateRoom: createAsyncAction(updateRoom, "room"),
    inviteBot: createAsyncAction(inviteBot, "inviteBot"),
    addRoom({ commit }, room: WheelOfFortuneRoom) {
      commit("ADD_ROOM", room)
    },
    setRoomToJoin({ commit }, room: WheelOfFortuneRoom | null) {
      commit("SET_ROOM_TO_JOIN", room)
    },
    setRoomToView({ commit }, room: WheelOfFortuneRoom | null) {
      commit("SET_ROOM_TO_VIEW", room)
      commit("CLEAR_INVITE_BOT", null)
    },
  },
}

export default wheelOfFortuneStore
